import { get, isEmpty } from "lodash";
import { Panel, TableRow } from "@/components";
import { NO_VALUE } from "@/constants";
import { AreasDetailsSummaryProps } from "./types";
import { FC } from "react";

export const AreasDetailsSummary: FC<AreasDetailsSummaryProps> = ({
  areas,
}) => {
  return (
    <Panel header="Areas">
      <TableRow
        label="Locations"
        value={
          !isEmpty(areas)
            ? areas
                ?.map(area => {
                  const AreaNameE = get(area, "AreaNameE", null);
                  const AreaNameEn = get(area, "AreaNameEn", null);

                  return AreaNameE || AreaNameEn || NO_VALUE;
                })
                .join(", ")
            : NO_VALUE
        }
      />
    </Panel>
  );
};
